import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'
import { ButtonStrip } from '../buttons'
import { DraggablePanel, DraggableHandle } from './DraggablePanel'

export interface ModalWindowProps {
  title: string | JSX.Element
  shadow?: boolean
  dataTestId?: string
  children?: React.ReactNode
  onEscKey?: () => void
}

const ModalWrapper = styled.div<{ shadow?: boolean }>`
  min-width: 402px;
  background-color: white;
  border-radius: ${constants.panelBorderRadius};
  border: 1px solid ${constants.CORE_PRIMARY_3};
  box-shadow: ${({ shadow = false }) => (shadow ? `5px 5px 8px 1px #8e8e8e5c` : 'none')};
`

export const ModalTitle = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  justify-content: space-between;
  padding: 0 20px;
  height: 77px;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 20px;
  color: #191e29;
  user-select: none;
  cursor: default;
`

export const ModalFooter = styled(ButtonStrip)`
  width: 100%;
  flex: 0 0 auto;
  padding: 20px;
  justify-content: flex-end;
`

ModalFooter.defaultProps = {
  spacing: '10px'
}

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  padding: 0 20px;
`

export class ModalWindow extends React.Component<ModalWindowProps> {
  render() {
    const { children, title, onEscKey, shadow } = this.props

    return (
      <DraggablePanel
        centered={true}
        onKeyDown={event => {
          if (onEscKey && event.code === 'Escape') {
            event.stopPropagation()
            onEscKey()
          }
        }}>
        <ModalWrapper data-test-id={`ModalWindow-${title}`} shadow={shadow}>
          <DraggableHandle>
            <ModalTitle data-test-id={'ModalWindow-ModalTitle-Title'}>{title}</ModalTitle>
          </DraggableHandle>

          {children}
        </ModalWrapper>
      </DraggablePanel>
    )
  }
}
